import React from "react"
import Button from "aldoo-ra/Button"
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline"

const StepNavigation = ({ 
  currentStep, 
  onPrevious, 
  onNext, 
  onGenerate,
  canProceed = true
}) => {
  const isFirstStep = currentStep === 1
  const isLastStep = currentStep === 4


  return (
    <div className="px-6 py-3">
      <div className="flex items-center justify-between max-w-4xl mx-auto">
        <div>
          {!isFirstStep && (
            <Button 
              variant="admin_secondary" 
              onClick={onPrevious}
              className="flex items-center"
            >
              <ChevronLeftIcon className="w-4 h-4 mr-1" />
              Previous
            </Button>
          )}
        </div>
        
        <div className="flex space-x-3">
          {isLastStep ? (
            <Button 
              variant="admin_primary" 
              onClick={onGenerate}
              disabled={!canProceed}
              className="flex items-center"
            >
              Create Release
            </Button>
          ) : (
            <Button 
              variant="admin_primary" 
              onClick={onNext}
              disabled={!canProceed}
              className="flex items-center"
            >
              Next
              <ChevronRightIcon className="w-4 h-4 ml-1" />
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default StepNavigation